import React from 'react';
import { Query } from 'react-apollo';
import Small from './Small';
import NotSmall from './NotSmall';
import { Loading, ErrorScreen, Viewport } from '../utils';
import { searchQuery } from '../../queries/search';
import { NotebookContext } from '../../context/NotebookContext';

class Search extends React.Component {
  state = {
    searchTerm: ''
  };

  handleSearchTerm = value => {
    this.setState({ searchTerm: value });
  };

  render() {
    const { searchTerm } = this.state;
    return (
      <NotebookContext.Consumer>
        {({notebook}) => (
          <Query query={searchQuery} variables={{ query: searchTerm, notebookId: notebook.id }}>
            {({ data: { search }, loading, error }) => {
              if (loading) {
                return <Loading />;
              }
              if (error) {
                return <ErrorScreen />;
              }

              const results = {
                trackers: search.edges.filter(edge => edge.node.__typename === 'Tracker') || [],
                subjects: search.edges.filter(edge => edge.node.__typename === 'Subject') || [],
                notes: search.edges.filter(edge => edge.node.__typename === 'Note') || []
              };

              return (
                <Viewport
                  small={
                    <Small
                      results={results}
                      searchTerm={searchTerm}
                      handleSearchTerm={this.handleSearchTerm}
                      {...this.props}
                    />
                  }
                  notSmall={
                    <NotSmall
                      results={results}
                      searchTerm={searchTerm}
                      handleSearchTerm={this.handleSearchTerm}
                      {...this.props}
                    />
                  }
                />
              );
            }}
          </Query>
        )}
      </NotebookContext.Consumer>
    );
  }
}

export default Search;
